import React from "react";
import { Outlet, Link } from "react-router-dom";
import logo_blue from "../Assets/logo/skilletix_blue.png";

const Footer = () => {
  return (
    <>
      <footer className="footer-area">
        <div className="footer-widget">
          <div className="container">
            <div className="row footer-widget-wrapper pt-100 pb-70">
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="footer-widget-box about-us">
                  <Link to="/" className="footer-logo">
                    <img
                      loading="lazy"
                      role="presentation"
                      decoding="async"
                      fetchpriority="high"
                      src={logo_blue}
                      alt="Logo"
                    />
                  </Link>
                  <p className="mb-4">
                    Welcome to Skilletix the ultimate platform connecting talent
                    with opportunity! We're more than just a job portal — we're
                    your partner in achieving professional growth.
                  </p>
                  <ul className="footer-contact">
                    <li>
                      <a href="tel:+919599171535">
                        <i className="far fa-phone" />
                        +9195991 71535
                      </a>
                    </li>
                    <li>
                      <a href="mailto:info@hashedbitinnovations.com">
                        <i className="far fa-envelope" />
                        <span className="__cf_email__">
                          hashedbitinnovations.com
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-2">
                <div className="footer-widget-box list">
                  <h4 className="footer-widget-title">Company</h4>
                  <ul className="footer-list">
                    <li>
                      <Link to="/aboutus">About Us</Link>
                    </li>
                    <li>
                      <Link to="/ourteam">Our Team</Link>
                    </li>
                    <li>
                      <Link to="/testimonials">Testimonials</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-2">
                <div className="footer-widget-box list">
                  <h4 className="footer-widget-title">Candidate</h4>
                  <ul className="footer-list">
                    <li>
                      <Link to="/jobs">Find Jobs</Link>
                    </li>
                    <li>
                      <Link to="/companies">Employers</Link>
                    </li>
                    <li>
                      <Link to={"/login"}>Sign In</Link>
                    </li>
                    <li>
                      <Link to="/register">Sign Up</Link>
                    </li>
                    <li>
                      <Link to="/deleteaccount">
                        Delete Account
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-2">
                <div className="footer-widget-box list">
                  <h4 className="footer-widget-title">Employer</h4>
                  <ul className="footer-list">
                    <li>
                      <Link to="/postjob">Post Job</Link>
                    </li>
                    <li>
                      <Link to="/manage-candidates">Manage Candidates</Link>
                    </li>
                    <li>
                      <Link to="/managejobs">Manage Jobs</Link>
                    </li>
                    <li>
                      <Link to="/register-employer">Register</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-2">
                <div className="footer-widget-box list">
                  <h4 className="footer-widget-title">Support</h4>
                  <ul className="footer-list">
                    <li>
                      <Link to="/contact-us">Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/complaints">Complaints</Link>
                    </li>
                    <li>
                      <Link to="/faq">Faq's</Link>
                    </li>
                    {/* <li>
                      <Link to="/privacypolicy">Privacy Policy</Link>
                    </li> */}
                    {/* <li>
                      <Link to="/termandconditions">Terms Of Service</Link>
                    </li> */}
                    <li>
                      <Link to="/feedback">Feedback</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className="container">
            <div className="row">
              <div className="col-md-6 align-self-center">
                <p className="copyright-text">
                  © Copyright <span id="date">2025</span>{" "}
                  <a href="#"> Skilletix </a> All Rights Reserved.
                </p>
              </div>
              <div className="col-md-6 align-self-center">
                <ul className="footer-social">
                  <li>
                    <a
                      href="https://www.facebook.com/hashedbitinnovations"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://x.com/HashedBit"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-twitter" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/hashedbit-innovations/posts/?feedView=all"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/@HashedBit"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <a href="#" id="scroll-top" style={{ display: "inline-block" }}>
        <i className="far fa-angle-up"></i>
      </a>
    </>
  );
};

export default Footer;
